import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import './styles.scss';

const BasicLayout = ({ children, classNames, title, classContent }) => (
  <div className={`b-layout${classNames ? ` ${classNames}` : ''}`}>
    <div className="container">
      <div className="row">
        <div className="col col-12">
          { title && (
            <h1 className="b-layout__title">
              <FormattedMessage id={title} />
            </h1>
          )}
          <div className={`b-layout__content${classContent ? `${classContent}` : ''}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
);

BasicLayout.propTypes = {
  children: PropTypes.element,
  classNames: PropTypes.string,
  title: PropTypes.string,
  classContent: PropTypes.string,
};

BasicLayout.defaultProps = {
  children: null,
  classNames: null,
  title: null,
  classContent: null
};

export default BasicLayout;
